<script>
export default {
    name:'expenses',
    props:{
        pointRecord:{
            default:()=>{
                return []
            },
            type:Array
        },
        exc: {
            default: ()=> {
                return ''
            },
        }
    }
}
</script>

<template>
    <div class="expenses">
        <el-timeline>
           <el-timeline-item 
           v-for="(i,k) in pointRecord"
           :key="k"
           :timestamp="new Date((i.add_time*1000)).toLocaleDateString()" 
           placement="top">
             <el-card>
                <p :class="['tiline-tile',i.type==1&&'add']">{{i.type==1?`增加了`:`减少了`}}{{i.point/exc}}</p>
                <h4 class="tiline-note">{{i.note}}</h4>
                <h4 class="tiline-point">当前结余：{{i.member_point/exc}}积分</h4>
            </el-card>
           </el-timeline-item>
        </el-timeline>
        <div class="nothing" v-if="pointRecord.length==0">
            <p><i class="el-icon-question "></i>暂无积分记录</p>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
.expenses
    height 650px
    overflow auto
    padding 0 50px 
.tiline-tile
    font-size 16px
    font-weight bold
    margin 5px 0
    color #ec0b0b
    &.add 
        color #67c23a
.tiline-note
    color #888
    margin-top 10px
.tiline-point
    color #888
    margin-top 10px
.nothing
    color #ccc
    font-size 36px
    text-align center
    height 100%
    padding-top 200px
</style>


